import React from 'react';
import EnhancedTab from '../../../../../../../../../lib/designSystem/TabSimulation';
import ComiteeModule from './components/ComiteeModule';

const OperationsModule = (props: any) => {
  const { selectedRequest, setOpen, parentSetUp } = props;
  const startValue = 0;
  const tabs = [
    {
      label: 'Comité',
      component: (
        <ComiteeModule
          selectedRequest={selectedRequest}
          setOpen={setOpen}
          parentSetUp={parentSetUp}
        />
      ),
    },
  ];
  return (
    <div>
      <EnhancedTab startValue={startValue} tabs={tabs} />
    </div>
  );
};

export default OperationsModule;
